import { useAtomValue } from "jotai";
import { accessTokenStore } from "../stores/accessToken";

export function useIsLogged() {
  return !!useAtomValue(accessTokenStore);
}
